import React from 'react';
import './TopicFormUsage.styl';
import PropTypes from 'prop-types';
import * as immutable from 'immutable';
import TopicFormProfileUsage from 'components/admin/topics/TopicFormProfileUsage';
import NewFilterWord from 'records/admin/topics/NewFilterWord';
import TopicFormTriggerUsage from 'components/admin/topics/TopicFormTriggerUsage';

/**
 * Given a topic, shows profiles associated with that topic, with teams and departments using each
 * profile. Also shows smart alerts referencing the topic.
 */
export default class TopicFormUsage extends React.PureComponent {
  static propTypes = {
    idToProfileMap: PropTypes.instanceOf(immutable.Map).isRequired,
    profileDepartmentAndTeamUsage: PropTypes.instanceOf(immutable.Map).isRequired,
    topic: PropTypes.instanceOf(NewFilterWord).isRequired,
    triggers: PropTypes.instanceOf(immutable.List).isRequired,
  };

  render() {
    const {idToProfileMap, profileDepartmentAndTeamUsage, topic, triggers} = this.props;

    return (
      <div className="topic-form-usage">
        <div className="topic-form-usage-header">
          <span>Topic Usage</span>
        </div>
        <div className="topic-form-usage-body">
          <div className="topic-form-usage-type">Profiles</div>
          <TopicFormProfileUsage
            idToProfileMap={idToProfileMap}
            profileDepartmentAndTeamUsage={profileDepartmentAndTeamUsage}
            topic={topic}
          />
          <div className="topic-form-usage-type">Smart Alerts</div>
          <TopicFormTriggerUsage triggers={triggers} />
        </div>
      </div>
    );
  }
}
